(ns bec-core.cljs.db
  (:require [bec-core.cljs.routes :as routes]))

(defonce default-db
  (let [query-map (routes/uri->query-map)
        initial-view (or (keyword (:view query-map)) :home)
        initial-props {:sub-view (keyword (:sub-view query-map))}]
    {:config {:locale "en-US"
              :time-zone "Europe/Oslo"}
     :selected-view [initial-view initial-props]
     :initial-query-map query-map}))